import script from "./sidebar-menu-section-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-menu-section-item.vue?vue&type=script&setup=true&lang=ts"

import "./sidebar-menu-section-item.vue?vue&type=style&index=0&id=5a1a4a76&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a1a4a76"]])

export default __exports__